import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(({ palette }) => ({
  root: {
    width: "95%",
    alignSelf: "flex-end",
    flexGrow: 1,
    padding: 8,
    textAlign: "right",
  },
  label: {
    paddingRight: 8,
  },
  transfersAndFeesResult: {
    borderBottom: `1px solid ${palette.grey[500]}`,
  },
  calculatedFinalNetPayInput: {
    textAlign: "right",
    border: "none",
    borderBottom: `1px solid ${palette.grey[500]}`,
    borderRadius: "0, 10px, 0, 10px",
    outline: "none",
    color: colors.black,
    fontSize: "14px",
    backgroundColor: palette.grey[200],
    padding: "27px 5px 10px",
    height: "1.1875em",
    boxSizing: "content-box",
    webkikTapHighlightColor: "transparent",
  },
}));

export default useStyles;
